import { createSelector } from '@reduxjs/toolkit';

export const selectCoordinator = createSelector(
  (state) => state.coordinator,
  (coordinator) => coordinator.coordinator
);
